var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useContext, useRef, useState } from 'react';
import { KebabSVG } from '@snack-uikit/icons';
import { Droplist } from '@snack-uikit/list';
import { Tag } from '@snack-uikit/tag';
import { useLayoutEffect } from '@snack-uikit/utils';
import { TEST_IDS } from '../../constants';
import { FunctionBadgeContext } from '../../context';
import styles from './styles.module.css';
export function FunctionBadge({ icon, options }) {
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const { setVisible } = useContext(FunctionBadgeContext);
    useLayoutEffect(() => {
        setVisible && setVisible(isOpen);
    }, [isOpen, setVisible]);
    const onClick = useCallback((e) => {
        e.stopPropagation();
        setIsOpen(isOpen => !isOpen);
    }, []);
    return (_jsx("span", { className: styles.wrapper, children: _jsx(Droplist, { trigger: 'clickAndFocusVisible', open: isOpen, onOpenChange: setIsOpen, widthStrategy: 'gte', scroll: true, "data-test-id": TEST_IDS.droplist, placement: 'bottom-end', triggerElemRef: buttonRef, items: options.map((_a) => {
                var { icon, tagLabel, onClick } = _a, item = __rest(_a, ["icon", "tagLabel", "onClick"]);
                return (Object.assign(Object.assign({}, item), { className: styles.item, beforeContent: icon, afterContent: tagLabel ? _jsx(Tag, { label: tagLabel }) : undefined, onClick: e => {
                        e.stopPropagation();
                        setIsOpen(false);
                        onClick === null || onClick === void 0 ? void 0 : onClick(e);
                    } }));
            }), children: _jsx("button", { type: 'button', "data-test-id": TEST_IDS.functionBadge, className: styles.button, onClick: onClick, ref: buttonRef, children: icon || _jsx(KebabSVG, {}) }) }) }));
}
